import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GroomAppointmentType } from '@appyvet/vetbooker-definitions/dist/appointment_type';

@Component({
  selector: 'app-appt-type-selector',
  template: `
    <div
      class="card-option-container"
      fxFill
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      fxLayoutAlign.lt-md="start center"
    >
      <div
        (click)="setSelectedType(type)"
        *ngFor="let type of types"
        [class.selected-card]="type === selectedType"
        class="selection-card"
        fxFlex="100%"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <div style="min-width: 30px; padding:0 10px">
          <mat-icon *ngIf="type === selectedType" style="margin:5px"
            >check_circle
          </mat-icon>
          <div *ngIf="type !== selectedType" class="empty-circle"></div>
        </div>
        <div class="column">
          <p
            [ngStyle]="{ color: type === selectedType ? '#FFFFFF' : '' }"
            class="card-header-text"
          >
            {{ type.displayName }}
          </p>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../components/common-components/patient-selector/patient-selector.scss',
  ],
})
export class ApptTypeSelectorComponent implements OnInit {
  @Input() types: GroomAppointmentType[];
  @Input() selectedType: GroomAppointmentType;
  @Output() selectedTypeChange = new EventEmitter<GroomAppointmentType>();

  constructor() {}

  ngOnInit(): void {}

  setSelectedType(selectedType: GroomAppointmentType) {
    this.selectedTypeChange.emit(selectedType);
  }
}
